import React from 'react';
import "../../css/cards/MaterItem.css"

import { IoPlay } from "react-icons/io5"

import ZBrush from "../../images/zbrush.png"

import Image from "react-image-webp";

import { openVideo } from "../../features/video";
import { useDispatch } from 'react-redux';


const MasterItem = ({ content }) => {
    
    const dispatch = useDispatch();
    return (
        <div className="MasterItem">
            <div className="item-header">
                <div
                    className="item-play"
                    onClick={() => {
                        // handleOpenModal(true);
                        dispatch(
                            openVideo({
                                modal: true,
                                url: content.video || "https://www.youtube.com/watch?v=9GzXcO0WEjI",
                                type: "common",
                            })
                        );
                    }}
                >
                    <IoPlay />
                </div>
                <h1 className="item-id">{content.id}</h1>
                <div className="item-filter"></div>
                <Image
                    webp={content.imageWebp}
                    src={content.image}
                    className="item-image"
                />
            </div>
            <div className="item-content">
                <div className="item-information">
                    <h2 className="item-title">{content.title}</h2>
                    <p className="item-desc">{content.description}</p>
                </div>
                <div className="item-blender">
                    <img src={ZBrush} alt="ZBrush" style={{width:125, height: 70}}/>
                </div>
            </div>
        </div>
    );
};

export default MasterItem;
